import React from 'react';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Drawer,
  DrawerProps,
  Input,
  Row,
} from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import moment from 'moment';

import { SmartSpace, playSound } from 'components/Sales/Smart/SmartComponent';
import { Label, SecondaryButton, message } from 'components/common';
import {
  COMMON_FLASH_MSG_DISPLAY_DURATION,
  HTTP_STATUS_OK,
  DEFAULT_US_DATE_FORMAT,
} from 'constants/config';

type Props = DrawerProps & {
  lotNumber?: string;
};

const DateFormat = DEFAULT_US_DATE_FORMAT;

const LotDetailDrawer = (props: Props) => {
  const { useState } = React;
  const [expirationDate, setExpirationData] = useState<any>();
  const [firstInDate, setFirstInDate] = useState(moment());
  const [generate, setGenerate] = useState(false);
  const [lotNumber, setLotNumber] = useState(props.lotNumber ? props.lotNumber : '');
  const [lotNumberInputVersion, setLotNumberInputVersion] = useState(0);
  const [manufacturingDate, setManufacturingDate] = useState<any>();
  const [noteText, setNoteText] = useState<string>();
  const [supplierLot, setSupplierLot] = useState<string>();

  const drawerFooter = () => {
    return (
      <Row>
        <Col span={12} style={{paddingRight: 5}}>
          <SecondaryButton
            onClick={onClose}
            size="large"
            style={{width: '100%'}}
          >
            <CloseOutlined />
            Cancel
          </SecondaryButton>
        </Col>
        <Col span={12} style={{paddingLeft: 5}}>
          <Button
            //disabled={!isSavable()}
            //onClick={onSave}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            <SaveOutlined />
            Save
          </Button>
        </Col>
      </Row>
    );
  };

  const onChangeAutoGenerate = (evt: any) => {
    const chk = evt.target.checked;

    setGenerate(chk);
  };

  const onChangeExpirationData = (d: any) => {
    setExpirationData(d);
  };

  const onChangeFirstInDate = (d: any) => {
    setFirstInDate(d);
  };

  const onChangeLotNumber = (evt: any) => {
    setLotNumber(evt.target.value);
  };

  const onChangeManufacturingDate = (d: any) => {
    setManufacturingDate(d);
  };

  const onChangeNoteText = (evt: any) => {
    //console.log('ch', evt);
    setNoteText(evt.target.value);
  };

  const onChangeSupplierLot = (evt: any) => {
    setSupplierLot(evt.target.value);
  };

  const onClose = (evt: any) => {
    if (props.onClose) props.onClose(evt);
  };

  return (<>
    <Drawer
      bodyStyle={{ padding: 10 }}
      closable={false}
      footer={drawerFooter()}
      footerStyle={{ padding: 10 }}
      onClose={onClose}
      placement="bottom"
      visible={props.visible}
      width={window.innerWidth}
      height={window.innerHeight - 56}
    >
      <SmartSpace className="mb-0">
        <Row>
          <Label theme={{fontSize: '1.3em'}}>LOT Information</Label>
        </Row>
        <div className="b-b-bordered mb-10 mt-10" />
        <Row align="middle" className="mb-5">
          <Label className="label-bold label-fs1_2 label-green1 label-required tail-colon2">LOT#</Label>
          {false && (
            <Checkbox checked={generate} onChange={onChangeAutoGenerate}>
              Automatically generate
            </Checkbox>
          )}
        </Row>
        {!generate && (
          <Input
            allowClear
            autoFocus
            className="fs-16"
            disabled
            key={`ln-input-${lotNumberInputVersion}`}
            onChange={onChangeLotNumber}
            placeholder="Input LOT# here"
            size="large"
            value={lotNumber}
          />
        )}
        <div className="mt-10 mb-5"><Label className="label-bold label-fs1_2 label-green1 label-required tail-colon2">First In Date</Label></div>
        <DatePicker
          allowClear={false}
          defaultValue={firstInDate}
          format={DateFormat}
          onChange={onChangeFirstInDate}
          size="large"
        />
        <div className="mt-10 mb-5"><Label className="label-bold label-fs1_2 label-green1 tail-colon2">Expiration Date</Label></div>
        <DatePicker
          defaultValue={expirationDate}
          format={DateFormat}
          onChange={onChangeExpirationData}
          size="large"
        />
        <div className="mt-10 mb-5"><Label className="label-bold label-fs1_2 label-green1 tail-colon2">Manufacturing Date</Label></div>
        <DatePicker
          defaultValue={manufacturingDate}
          format={DateFormat}
          onChange={onChangeManufacturingDate}
          size="large"
        />
        <div className="mt-5">
          <Label className="label-grey">You can set the default manufacturing date to the current date upon receipt and override it to the date of manufacture at the supplier, if applicable.</Label>
        </div>
        <div className="mt-10 mb-5"><Label className="label-bold label-fs1_2 label-green1 tail-colon2">Supplier LOT#</Label></div>
        <Input
          allowClear
          //autoFocus
          className="fs-16"
          defaultValue={supplierLot}
          onChange={onChangeSupplierLot}
          placeholder="Input Supplier LOT# here"
          size="large"
        />
        <div className="mt-10 mb-5"><Label className="label-bold label-fs1_2 label-green1 tail-colon2">Note</Label></div>
        <Input.TextArea
          allowClear
          defaultValue={noteText}
          onChange={onChangeNoteText}
          placeholder="Input note here"
          size="large"
        />
      </SmartSpace>
    </Drawer>
  </>);
};

export default LotDetailDrawer;

